export const SHOW_ADD_DEPARTMENT_EVENT = Symbol('SHOW_ADD_DEPARTMENT_EVENT')
